<div class="relative grid overflow-hidden">
  <div
    class="pb-5 w-full overflow-hidden"
    [style.--swiper-template-count]="templates.length"
    [style.--swiper-index]="index"
    [style.--swiper-offset]="offset + 'px'"
  >
    <div
      class="[--columnCount:1] md:[--columnCount:2] xl:[--columnCount:3] 2xl:[--columnCount:4] w-[calc(100%*var(--swiper-template-count)/var(--columnCount))] flex my-0 mx-auto translate-x-[calc(-100%/var(--swiper-template-count)*var(--swiper-index)+var(--swiper-offset))]"
      [ngClass]="{ 'transition-transform duration-200': !swiping }"
      libSwipe
      [swipeMode]="'horizontal'"
      (onSwipe)="onSwipe($event)"
      (onChangeOffset)="offset = $event.x"
      (onSwipeEvent)="swipeEvent($event)"
    >
      @for (tpl of templates; track tpl; let i = $index) {
        <div class="grow-0 shrink-0 basis-auto px-5" [style.width]="100 / templates.length + '%'">
          <ng-content />
          <!-- please don't remove this: https://github.com/angular/angular/issues/50543 -->
          <ng-container [ngTemplateOutlet]="tpl"></ng-container>
        </div>
      }
    </div>
  </div>
  @if (templates.length > 1 && numberOfDots > 1) {
    <div class="flex justify-center pb-5">
      @for (t of templates; track t; let i = $index) {
        <div
          class="w-3 h-3 rounded-full my-0 mx-1 bg-[--color-gray-3] cursor-pointer [&:nth-child(1)]:[&:nth-last-child(1)]:hidden md:[&:nth-child(1)]:[&:nth-last-child(2)]:hidden md:[&:nth-last-child(1)]:hidden xl:[&:nth-child(1)]:[&:nth-last-child(3)]:hidden xl:[&:nth-last-child(2)]:hidden 2xl:[&:nth-child(1)]:[&:nth-last-child(4)]:hidden 2xl:[&:nth-last-child(3)]:hidden"
          [ngClass]="{ 'bg-[--color-primary]': index === i }"
          (click)="index = i"
        ></div>
      }
    </div>
  }
  @if (!hideArrows && templates.length > 1 && numberOfDots > 1) {
    <div>
      <div
        class="top-1/2 -translate-y-1/2 left-[5px] after:rotate-[-135deg] absolute w-5 h-5 cursor-pointer after:absolute after:w-5 after:h-5 after:border-t-2 after:border-r-2 after:border-[--color-primary]"
        [ngClass]="{ 'pointer-events-none opacity-25': index === 0 }"
        (click)="onSwipe('left')"
      ></div>
      <div
        class="top-1/2 -translate-y-1/2 absolute right-[5px] after:rotate-45 w-5 h-5 cursor-pointer after:absolute after:w-5 after:h-5 after:border-t-2 after:border-r-2 after:border-[--color-primary]"
        [ngClass]="{ 'pointer-events-none opacity-25': index === numberOfDots - 1 }"
        (click)="onSwipe('right')"
        data-testid="swiper-right-arrow"
      ></div>
    </div>
  }
</div>
